import { Spinner } from '@heroui/spinner';
import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'lg',
  message = 'Loading...',
}) => {
  return (
    <div className='flex flex-col justify-center items-center min-h-screen bg-background'>
      <Spinner size={size} color='primary' />
      {message && <p className='mt-4 text-foreground-500'>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
